import React, { FC } from 'react'
import { Abilities, AbilityTuple, Generics, IfString, SubjectType } from '@casl/ability'
import { Outlet } from 'react-router-dom'

import { Can } from './Can'
import { AppAbility } from './types'
import { Errors } from 'pages/Errors'

// this type is copied from @casl/react temporarily
type AbilityCanProps<T extends Abilities, Else = IfString<T, {
  do: T;
} | {
  I: T;
}>> = T extends AbilityTuple ? {
  do: T[0];
  on: T[1];
  field?: string;
} | {
  I: T[0];
  a: Extract<T[1], SubjectType>;
  field?: string;
} | {
  I: T[0];
  an: Extract<T[1], SubjectType>;
  field?: string;
} | {
  I: T[0];
  this: Exclude<T[1], SubjectType>;
  field?: string;
} : Else;
type LocalBoundCanProps = AbilityCanProps<Generics<AppAbility>['abilities']>;

export const CanRoute: FC<LocalBoundCanProps> = (props) => {
  return (
    <Can passThrough={true} {...props}>
      {isAllowed => isAllowed
        ? (
          <Outlet />
        ) : (
          <Errors.Unauthorized />
        )
      }
    </Can>
  )
}
